import { RouterModule } from "@angular/router";
import { PractitionerCardComponent } from "./../practitioners/practitioner-card/practitioner-card.component";
import {
  MatDatepickerModule,
  MatNativeDateModule,
  MatSelectModule,
  MatIconModule,
  MatButtonModule,
  MatMenuModule,
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MultiselectComponent } from "./components/multiselect/multiselect.component";
import { EqualPipe } from "./pipes/equal.pipe";
import { FilterPipe } from "./pipes/filter.pipe";
import { SearchbarComponent } from "./components/searchbar/searchbar.component";
import { CardComponent } from "./components/card/card.component";
import { PatientCardComponent } from "../patients/patient-card/patient-card.component";
import { ReferralsCreateComponent } from "./components/referrals-create/referrals-create.component";
import { ReferralsEditComponent } from "./components/referrals-edit/referrals-edit.component";
import { ReferralsListComponent } from "./components/referrals-list/referrals-list.component";
import { ConfirmDialog } from "./components/confirm-dialog/confirm-dialog.component";
import { PatientNextApptComponent } from "./components/patient-next-appt/patient-next-appt.component";
import { AppStoreCTABarComponent } from "./components/AppStoreCTABar/AppStoreCTABar.component";
import { PatientSearchComponent } from "../physician/patient/patient-search/patient-search.component";
import {
  SidebarPhysicianEditComponent,
  SideBarEditDialogOverview,
} from "../physician/profile/physician/sidebar-physician-edit/sidebar-physician-edit.component";
import { MaterialModule } from "../material/material-module";
import { CoreModule } from "../core/core.module";
import { CKEditorModule } from "ckeditor4-angular";
import { PhysicianOptionComponent } from "../physician/shared/physician-option/physician-option.component";
import { PatientNewMinumumComponent } from "../patients/patient-new/patient-new-minumum/patient-new-minumum.component";
import { RightSidebarComponent } from "./components/right-sidebar/right-sidebar.component";
import { WindowLoaderComponent } from "./components/window-loader/window-loader.component";
import { NgxMaskModule } from "ngx-mask";
import { PreviewDocumentComponent } from "./components/preview-document/preview-document.component";
import { PreviewImagesComponent } from "./components/preview-images/preview-images.component";
import { SupportRequestComponent } from "./components/SupportRequest/SupportRequest.component";
import { RightBarComponentDirective } from "./components/dynamic-right-sidebar/rightBarComponentDirective";
import { DynamicRightSidebarComponent } from "./components/dynamic-right-sidebar/dynamic-right-sidebar.component";

import { PatientSelectorComponent } from "../patients/shared/patient-selector/patient-selector.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { ConfirmationComponent } from "./notification-center/confirmation/confirmation.component";
import { PadCharsLeftPipe } from "./pipes/pad-chars-left.pipe";
import { AppyPractitionerNameLabelComponent } from "./components/appy-practitioner-name-label/appy-practitioner-name-label.component";
import { PhysicianReferPatientComponent } from "../physician/patient/physician-refer-patient/physician-refer-patient.component";
import { SummaryComponent } from "../physician/appointments/summary/summary.component";
import { GetAgePipe } from "./pipes/get-age.pipe";
import { GetValueForCodePipe } from "./pipes/get-value-for-code.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { GetShortNamePipe } from "./pipes/get-short-name.pipe";
import { PhonePipe } from "../shared/pipes/phone.pipe";
import { PhoneContactPreferencesPipe } from "../shared/pipes/phone-contact-preferences.pipe";
import { MailContactPreferencesPipe } from "../shared/pipes/mail-contact-preferences.pipe";
import { TimeFormat } from "./pipes/get-timeformat.pipe";
import { PhysicianPatientProfileComponent } from "../physician/patient/physician-patient-profile/physician-patient-profile.component";
import { PhysicianPatientSidebarComponent } from "../physician/patient/physician-patient-sidebar/physician-patient-sidebar.component";
import { ProfilePhotoComponent } from "./profile-photo/profile-photo.component";
import { PatientAppointmentsListComponent } from "../physician/patient/patient-appointments-list/patient-appointments-list.component";
import { PatientReferalListComponent } from "../physician/patient/patient-referal-list/patient-referal-list.component";
import { GetPatientDataOptionPipe } from "./pipes/get-patient-data-option.pipe";
import { DragAndDropDirective } from "./directives/DragAndDrop.directive";
import { TargetBlankDirective } from "./directives/target-blank/target-blank.directive";
import { InsuranceBenefitsComponent } from "./components/insurance-benefits/insurance-benefits.component";
import { FormCardViewComponent } from "../physician/formdocs/form-card-view/form-card-view.component";
import { FormFolderViewComponent } from "../physician/formdocs/form-folder-view/form-folder-view.component";
import { FormEditFolderComponent } from "../physician/formdocs/form-edit-folder/form-edit-folder.component";
import { FormFolderManagementComponent } from "../physician/formdocs/form-folder-management/form-folder-management.component";
import { FormDocumentDetailsComponent } from "../physician/formdocs/form-document-details/form-document-details.component";
import { FormDocumentPreviewComponent } from "../physician/formdocs/form-document-preview/form-document-preview.component";
import { FormPreviewFromBuilderDtoComponent } from "../physician/formdocs/form-preview/form-preview-from-builder-dto.component";
import { FormSelectFoldersComponent } from "../physician/formdocs/form-select-folders/form-select-folders.component";
import { FormDocumentBuilderComponent } from "../physician/formdocs/form-document-builder/form-document-builder.component";
import { FormPreviewComponent } from "../physician/formdocs/form-preview/form-preview.component";
import { FormHeaderComponent } from "../physician/formdocs/form-document-builder/form-header/form-header.component";
import { FormFooterComponent } from "../physician/formdocs/form-document-builder/form-footer/form-footer.component";
import { FormBlockParagraphComponent } from "../physician/formdocs/form-document-builder/form-block-paragraph/form-block-paragraph.component";
import { FormBlockInputComponent } from "../physician/formdocs/form-document-builder/form-block-input/form-block-input.component";
import { FormBlockOptionComponent } from "../physician/formdocs/form-document-builder/form-block-option/form-block-option.component";
import { FormBlockDecisionComponent } from "../physician/formdocs/form-document-builder/form-block-decision/form-block-decision.component";
import { FormBlockSignatureComponent } from "../physician/formdocs/form-document-builder/form-block-signature/form-block-signature.component";
import { FormBlockDataComponent } from "../physician/formdocs/form-document-builder/form-block-data/form-block-data.component";
import { FormBlockContainerComponent } from "../physician/formdocs/form-document-builder/form-block-container/form-block-container.component";
import { FormBlockItemComponent } from "../physician/formdocs/form-document-builder/form-block-item/form-block-item.component";
import { SymptomsComponent } from "../physician/profile/physician/sidebar-physician-edit/symptoms/symptoms.component";
import { SendMessageComponent } from "../physician/chat/send-message/send-message.component";
import { SendMultipleMessagesComponent } from "../physician/chat/send-multiple-messages/send-multiple-messages.component";
import { PreviewPdfComponent } from "./components/preview-pdf/preview-pdf.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { TreatmentComponent } from "../physician/profile/physician/sidebar-physician-edit/treatment/treatment.component";
import { PatientInsuranceDialogComponent } from "../physician/patient/physician-patient-profile/patient-insurance-dialog/patient-insurance-dialog.component";
import { PiCopayComponent } from "../physician/patient/physician-patient-profile/patient-insurance-dialog/pi-copay/pi-copay.component";
import { PiLimitationComponent } from "../physician/patient/physician-patient-profile/patient-insurance-dialog/pi-limitation/pi-limitation.component";
import { ProfileLayoutComponent } from "./components/profile-layout/profile-layout.component";
import { FormAcroformdesignComponent } from "../physician/formdocs/form-acroformdesign/form-acroformdesign.component";
import { EditPracticeComponent } from "./components/profile-layout/edit-practice/edit-practice.component";
import { EditProviderProfileComponent } from "./components/profile-layout/edit-provider-profile/edit-provider-profile.component";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { NgSelectModule } from "@ng-select/ng-select";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatCarouselModule } from "@ngmodule/material-carousel";
import { UpdatedTimePipe } from "./pipes/updated-time.pipe";
import { CardDialogComponent } from "./components/profile-layout/card-dialog/card-dialog.component";
import { TimingCardDialogComponent } from "./components/profile-layout/timing-card-dialog/timing-card-dialog.component";
import { DayOffComponent } from "../physician/day-off/day-off.component";
import { PhysiciansCardDialogComponent } from "./components/profile-layout/physicians-card-dialog/physicians-card-dialog.component";
import { HospitalCardDialogComponent } from "./components/profile-layout/hospital-card-dialog/hospital-card-dialog.component";
import { FormsSideBarComponent } from "../physician/patient/forms-sidebar.component/forms-sidebar.component";
import { PatientProfileComponent } from "../patient/patient-profile/patient-profile.component";
import { ProfilePatientInfoComponent } from "../patient/patient-profile/profile/profile-patient-info/profile-patient-info.component";
import { ProfileAddressInfoComponent } from "../patient/patient-profile/profile/profile-address-info/profile-address-info.component";
import { PatientAddressEditComponent } from "../patient/patient-profile/profile-edit/patient-address-edit/patient-address-edit.component";
import { PatientAdvancedDirectiveEditComponent } from "../patient/patient-profile/profile-edit/patient-advanced-directive-edit/patient-advanced-directive-edit.component";
import { PatientChildrenGuardianEditComponent } from "../patient/patient-profile/profile-edit/patient-children-guardian-edit/patient-children-guardian-edit.component";
import { PatientDriverLicenseEditComponent } from "../patient/patient-profile/profile-edit/patient-driver-license-edit/patient-driver-license-edit.component";
import { PatientEmergencyContactEditComponent } from "../patient/patient-profile/profile-edit/patient-emergency-contact-edit/patient-emergency-contact-edit.component";
import { PatientPharmacyPreferencesEditComponent } from "../patient/patient-profile/profile-edit/patient-pharmacy-preferences-edit/patient-pharmacy-preferences-edit.component";
import { SidebarPatientEditComponent } from "../patient/patient-profile/profile-edit/sidebar-patient-edit/sidebar-patient-edit.component";
import { AddressComponent } from "../patient/patient-profile/profile/address/address.component";
import { AdvancedDirectivesComponent } from "../patient/patient-profile/profile/advanced-directives/advanced-directives.component";
import { ChildrenOrGuardianComponent } from "../patient/patient-profile/profile/children-or-guardian/children-or-guardian.component";
import { PharmacyPreferencesComponent } from "../patient/patient-profile/profile/pharmacy-preferences/pharmacy-preferences.component";
import { ProfileContactPreferencesComponent } from "../patient/patient-profile/profile/profile-contact-preferences/profile-contact-preferences.component";
import { ProfileDriverLicenseComponent } from "../patient/patient-profile/profile/profile-driver-license/profile-driver-license.component";
import { ProfileEmergencyContactInfoComponent } from "../patient/patient-profile/profile/profile-emergency-contact-info/profile-emergency-contact-info.component";
import { ProfileEmployementInfoComponent } from "../patient/patient-profile/profile/profile-employement-info/profile-employement-info.component";
import { PatientRegistrationComponent } from "../patient-registration/patient-registration.component";
import { ConfirmDeleteDialogComponent } from './components/confirm-delete-dialog/confirm-delete-dialog.component';
import { AddPhysiciansDialogComponent } from './components/add-physicians-dialog/add-physicians-dialog.component';
import { PhysicianInfoComponent } from './components/physician-info/physician-info.component';
import { PatientInsuranceComponent } from "../patient/patient-profile/profile/patient-insurance/patient-insurance.component";
import { PatientInsuranceEditComponent } from "../patient/patient-profile/profile-edit/patient-insurance-edit/patient-insurance-edit.component";
import { ConditionsComponent } from './components/conditions/conditions.component';
import { EditPhysicianInfoComponent } from './components/physician-info/edit-physician-info/edit-physician-info.component';
import { PatientFinancialInfoComponent } from "../patient/patient-profile/profile/patient-financial-info/patient-financial-info.component";
import { PatientFinancialInfoEditComponent } from "../patient/patient-profile/profile-edit/patient-financial-info-edit/patient-financial-info-edit.component";
import { PracticeLocationComponent } from './components/practice-location/practice-location.component';
import { SharedTreatmentComponent } from './components/shared-treatment/shared-treatment.component';
import { NgxMatDateFormats, NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular-material-components/moment-adapter";
import { PatientHealthComponent } from "../patient/patient-health/patient-health.component";
import { PatientPastMedicalHistoryComponent } from "../patient/patient-health/patient-past-medical-history/patient-past-medical-history.component";
import { PatientFamilyHistoryComponent } from "../patient/patient-health/patient-family-history/patient-family-history.component";
import { PatientSocialHistoryComponent } from "../patient/patient-health/patient-social-history/patient-social-history.component";
import { PatientSurgicalHistoryComponent } from "../patient/patient-health/patient-surgical-history/patient-surgical-history.component";
import { PatientImmunizationsHistoryComponent } from "../patient/patient-health/patient-immunizations-history/patient-immunizations-history.component";
import { PatientAllergiesComponent } from "../patient/patient-health/patient-allergies/patient-allergies.component";
import { PatientMedicationComponent } from "../patient/patient-health/patient-medication/patient-medication.component";
import { RatingReviewsComponent } from "./components/rating-reviews/rating-reviews.component";
import { ServicesComponent } from './components/services/services.component';
import { DynamicAutocompleteComponent } from './components/dynamic-autocomplete/dynamic-autocomplete.component';
import { PatientFavoritesComponent } from "../patient/patient-favorites/patient-favorites.component";
import { RequestAppointmentDialogComponent } from './components/request-appointment-dialog/request-appointment-dialog.component';
import { PracticeServiceComponent } from './components/practice-service/practice-service.component';
import { HospitalAffiliationsComponent } from './components/hospital-affiliations/hospital-affiliations.component';
import { PatientAppointmentsComponent } from "../patient/patient-appointments/patient-appointments.component";
import { RescheduleAppointmentComponent } from './components/reschedule-appointment/reschedule-appointment.component';
import { PatientCreditCardComponent } from "../patient/patient-profile/profile/patient-credit-card/patient-credit-card.component";
import { CreditCardComponent } from "../market-place/market-place-home/product-checkout/credit-card/credit-card.component";
import { UserAddDialogComponent } from './components/user-add-dialog/user-add-dialog.component';
import { FindCareComponent } from './components/find-care/find-care.component';
import { FindCareTeamComponent } from './components/find-care/find-care-team/find-care-team.component';
import { AgmCoreModule } from "@agm/core";
import { PhysicanCardComponent } from './components/physican-card/physican-card.component';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { RegistrationDocumentsComponent } from './components/registration-documents/registration-documents.component';
import { PractitionerInsuranceComponent } from './components/practitioner-insurance/practitioner-insurance.component';
import { MembersSearchComponent } from "../agency/members-search/members-search.component";
import { PatientSubscriptionsComponent } from "../patient/patient-subscriptions/patient-subscriptions.component";
import { EmployerProfileComponent } from "../employer/employer-profile/employer-profile.component";
import { PatientChoosePlanComponent } from "../patient/patient-choose-plan/patient-choose-plan.component";
import { PatientActivePlanComponent } from "../patient/patient-active-plan/patient-active-plan.component";
import { PatientCheckoutComponent } from "../patient/patient-checkout/patient-checkout.component";
import { PatientFamilyDetailsComponent } from "../patient/patient-family-details/patient-family-details.component";
import { PatientPlanDetailsComponent } from "../patient/patient-plan-details/patient-plan-details.component";
import { PatientTeldacplanComponent } from "../patient/patient-teldacplan/patient-teldacplan.component";
import { PatientTeldacFaqplanComponent } from "../patient/patient-teldac-faqplan/patient-teldac-faqplan.component";
import { PatientHealthadvocatePlanComponent } from "../patient/patient-healthadvocate-plan/patient-healthadvocate-plan.component";
import { PatientNbfitnessPlanComponent } from "../patient/patient-nbfitness-plan/patient-nbfitness-plan.component";
import { PatientHealthadvocatefaqPlanComponent } from "../patient/patient-healthadvocatefaq-plan/patient-healthadvocatefaq-plan.component";
import { PatientNbrxPlanComponent } from "../patient/patient-nbrx-plan/patient-nbrx-plan.component";
import { PatientManifestrxPlanComponent } from "../patient/patient-manifestrx-plan/patient-manifestrx-plan.component";
import { PatientLifelockessentialPlanComponent } from "../patient/patient-lifelockessential-plan/patient-lifelockessential-plan.component";
import { PatientLabtestingPlanComponent } from "../patient/patient-labtesting-plan/patient-labtesting-plan.component";
import { PatientNbdealsPlanComponent } from "../patient/patient-nbdeals-plan/patient-nbdeals-plan.component";
import { PatientNbtravelPlanComponent } from "../patient/patient-nbtravel-plan/patient-nbtravel-plan.component";
import { PatientSponsoredPlanComponent } from "../patient/patient-sponsored-plan/patient-sponsored-plan.component";
import { PatientPetrxPlanComponent } from "../patient/patient-petrx-plan/patient-petrx-plan.component";
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ChartsModule, ThemeService } from "ng2-charts";
import { PatientPaymentMethodComponent } from "../patient/patient-payment-method/patient-payment-method.component";
import { PatientPrivacyPolicyComponent } from "../patient/patient-privacy-policy/patient-privacy-policy.component";

@NgModule({
  imports: [
    NgSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MaterialModule,
    CoreModule,
    AgmCoreModule,
    CKEditorModule,
    NgxMaskModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    PdfViewerModule,
    NgxMaterialTimepickerModule,
    NgxMatMomentModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    ScrollingModule,
    MatCarouselModule.forRoot(),
    ChartsModule,
  ],
  declarations: [
    DayOffComponent,
    GetAgePipe,
    GetValueForCodePipe,
    SafePipe,
    GetShortNamePipe,
    PhonePipe,
    PhoneContactPreferencesPipe,
    MailContactPreferencesPipe,
    FilterPipe,
    EqualPipe,
    MultiselectComponent,
    CardComponent,
    SearchbarComponent,
    ReferralsCreateComponent,
    ReferralsEditComponent,
    ReferralsListComponent,
    PatientCardComponent,
    PractitionerCardComponent,
    ConfirmDialog,
    PatientNextApptComponent,
    AppStoreCTABarComponent,
    PhysicianOptionComponent,
    PatientSelectorComponent,
    PatientSearchComponent,
    SidebarPhysicianEditComponent,
    PatientNewMinumumComponent,
    RightSidebarComponent,
    WindowLoaderComponent,
    SideBarEditDialogOverview,
    PreviewDocumentComponent,
    PreviewImagesComponent,
    SupportRequestComponent,
    RightBarComponentDirective,
    DynamicRightSidebarComponent,
    DragAndDropDirective,
    AppyPractitionerNameLabelComponent,
    ConfirmationComponent,
    TargetBlankDirective,
    PadCharsLeftPipe,
    PhysicianReferPatientComponent,
    SendMessageComponent,
    SendMultipleMessagesComponent,
    SummaryComponent,
    TimeFormat,
    PhysicianPatientProfileComponent,
    PhysicianPatientSidebarComponent,
    PatientAppointmentsListComponent,
    PatientReferalListComponent,
    ProfilePhotoComponent,
    GetPatientDataOptionPipe,
    InsuranceBenefitsComponent,
    PatientInsuranceDialogComponent,
    FormCardViewComponent,
    FormFolderViewComponent,
    FormFolderManagementComponent,
    FormEditFolderComponent,
    FormDocumentDetailsComponent,
    FormDocumentPreviewComponent,
    FormAcroformdesignComponent,
    FormDocumentBuilderComponent,
    FormHeaderComponent,
    FormFooterComponent,
    FormBlockParagraphComponent,
    FormBlockInputComponent,
    FormBlockOptionComponent,
    FormBlockDecisionComponent,
    FormBlockSignatureComponent,
    FormBlockDataComponent,
    FormBlockContainerComponent,
    FormBlockItemComponent,
    FormPreviewComponent,
    FormPreviewFromBuilderDtoComponent,
    FormSelectFoldersComponent,
    SymptomsComponent,
    TreatmentComponent,
    PreviewPdfComponent,
    PiCopayComponent,
    PiLimitationComponent,
    ProfileLayoutComponent,
    EditProviderProfileComponent,
    EditPracticeComponent,
    UpdatedTimePipe,
    CardDialogComponent,
    TimingCardDialogComponent,
    PhysiciansCardDialogComponent,
    HospitalCardDialogComponent,
    FormsSideBarComponent,
    PatientRegistrationComponent,
    // Added patient profile components because we are using it in physician-patient profile.
    PatientProfileComponent,
    EmployerProfileComponent,
    ProfilePatientInfoComponent,
    ProfileAddressInfoComponent,
    ProfileDriverLicenseComponent,
    ProfileContactPreferencesComponent,
    ProfileEmployementInfoComponent,
    ProfileEmergencyContactInfoComponent,
    AddressComponent,
    ChildrenOrGuardianComponent,
    PharmacyPreferencesComponent,
    AdvancedDirectivesComponent,
    SidebarPatientEditComponent,
    PatientAddressEditComponent,
    PatientDriverLicenseEditComponent,
    PatientEmergencyContactEditComponent,
    PatientChildrenGuardianEditComponent,
    PatientAdvancedDirectiveEditComponent,
    PatientPharmacyPreferencesEditComponent,
    ConfirmDeleteDialogComponent,
    AddPhysiciansDialogComponent,
    PhysicianInfoComponent,
    PatientInsuranceComponent,
    PatientInsuranceEditComponent,
    ConditionsComponent,
    EditPhysicianInfoComponent,
    PatientFinancialInfoComponent,
    PatientFinancialInfoEditComponent,
    PatientPastMedicalHistoryComponent,
    PatientFamilyHistoryComponent,
    PatientSocialHistoryComponent,
    PatientSurgicalHistoryComponent,
    PatientImmunizationsHistoryComponent,
    PracticeLocationComponent,
    PatientAllergiesComponent,
    PatientMedicationComponent,
    PatientHealthComponent,
    SharedTreatmentComponent,
    RatingReviewsComponent,
    ServicesComponent,
    DynamicAutocompleteComponent,
    RequestAppointmentDialogComponent,
    PatientFavoritesComponent,
    PracticeServiceComponent,
    HospitalAffiliationsComponent,
    PatientAppointmentsComponent,
    RescheduleAppointmentComponent,
    PatientCreditCardComponent,
    CreditCardComponent,
    UserAddDialogComponent,
    FindCareComponent,
    FindCareTeamComponent,
    PhysicanCardComponent,
    NumberOnlyDirective,
    RegistrationDocumentsComponent,
    PractitionerInsuranceComponent,
    MembersSearchComponent,
    PatientSubscriptionsComponent,
    PatientChoosePlanComponent,
    PatientPrivacyPolicyComponent,
    PatientActivePlanComponent,
    PatientPaymentMethodComponent,
    PatientCheckoutComponent,
    PatientFamilyDetailsComponent,
    PatientPlanDetailsComponent,
    PatientTeldacplanComponent,
    PatientTeldacFaqplanComponent,
    PatientHealthadvocatePlanComponent,
    PatientNbfitnessPlanComponent,
    PatientHealthadvocatefaqPlanComponent,
      PatientNbrxPlanComponent,
        PatientManifestrxPlanComponent,
        PatientLifelockessentialPlanComponent,
        PatientLabtestingPlanComponent,
        PatientNbdealsPlanComponent,
        PatientNbtravelPlanComponent,
        PatientSponsoredPlanComponent,
        PatientPetrxPlanComponent,
        DashboardComponent,

  ],
  exports: [
    GetAgePipe,
    GetValueForCodePipe,
    SafePipe,
    GetShortNamePipe,
    PhonePipe,
    PhoneContactPreferencesPipe,
    MailContactPreferencesPipe,
    FilterPipe,
    EqualPipe,
    PadCharsLeftPipe,
    MultiselectComponent,
    CardComponent,
    SearchbarComponent,
    ReferralsCreateComponent,
    ReferralsEditComponent,
    ReferralsListComponent,
    ConfirmDialog,
    PatientCardComponent,
    PractitionerCardComponent,
    PatientNextApptComponent,
    AppStoreCTABarComponent,
    PhysicianOptionComponent,
    PatientSelectorComponent,
    AppStoreCTABarComponent,
    PatientSearchComponent,
    SidebarPhysicianEditComponent,
    RightSidebarComponent,
    WindowLoaderComponent,
    SidebarPhysicianEditComponent,
    SupportRequestComponent,
    DynamicRightSidebarComponent,
    ConfirmationComponent,
    AppyPractitionerNameLabelComponent,
    PhysicianReferPatientComponent,
    SendMessageComponent,
    SendMultipleMessagesComponent,
    SummaryComponent,
    TimeFormat,
    ProfilePhotoComponent,
    GetPatientDataOptionPipe,
    FormFolderViewComponent,
    FormEditFolderComponent,
    ProfileLayoutComponent,
    EditProviderProfileComponent,
    UpdatedTimePipe,
    FormsSideBarComponent,
    PhysicianPatientProfileComponent,
    PdfViewerModule,
    DynamicAutocompleteComponent,
    NumberOnlyDirective,
    MembersSearchComponent,
    DashboardComponent
  ],
  entryComponents: [
    ReferralsCreateComponent,
    ReferralsEditComponent,
    ConfirmDialog,
    PatientNextApptComponent,
    SideBarEditDialogOverview,
    PreviewDocumentComponent,
    PreviewImagesComponent,
    SupportRequestComponent,
    ConfirmationComponent,
    PhysicianPatientProfileComponent,
    PatientAppointmentsListComponent,
    PatientReferalListComponent,
    ProfilePhotoComponent,
    InsuranceBenefitsComponent,
    PatientInsuranceDialogComponent,
    FormDocumentPreviewComponent,
    FormPreviewFromBuilderDtoComponent,
    PreviewPdfComponent,
    ConfirmDeleteDialogComponent,
    AddPhysiciansDialogComponent,
    RequestAppointmentDialogComponent,
    RescheduleAppointmentComponent,
    CreditCardComponent,
    UserAddDialogComponent,
    PatientFamilyDetailsComponent,
    DashboardComponent
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    EqualPipe,
    GetValueForCodePipe,
    ThemeService,
  ],
})
export class SharedModule { }
